import { Card, Icon, IconButton, Modal } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";
import { useState } from "react";
import parse from "html-react-parser";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90vw',
    maxWidth: '1000px',
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
    maxHeight: '90vh',
    overflowY: 'auto',
};

function MDModal({
    show,
    close,
    header,
    dados, }) {

    const [isDownload, setIsDownload] = useState(false);
    const [hasEmojiWarning, setHasEmojiWarning] = useState(false);


    const containsHTML = (str) => /<\/?[a-z][\s\S]*>/i.test(str);

    const formatJSON = (json) => {
        try {
            const parsed = JSON.parse(json);
            const formatted = JSON.stringify(parsed, null, 2);
            return formatted !== 'null' ? formatted : null;
        } catch (error) {
            return null;
        }
    };


    return (
        <Modal
            open={show}
            onClose={close}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Card sx={style}>
                <MDTypography id="modal-modal-title" variant="h6" component="h2" mb={3}>
                    {header}
                </MDTypography>
                <IconButton
                    aria-label="close"
                    onClick={close}
                    sx={{ position: 'absolute', top: 8, right: 8 }}
                >
                    <MDTypography variant="body1" lineHeight={1}>
                        <Icon color="light">close</Icon>
                    </MDTypography>
                </IconButton>

                <MDBox
                    sx={{
                        maxHeight: 600,
                        overflowY: 'auto',
                        padding: 2,
                    }}
                >
                    <MDTypography variant="body1" component="div">
                        {containsHTML(dados) ? (
                            <span>{parse(dados)}</span>
                        ) : formatJSON(dados) ? (
                            <pre style={{
                                whiteSpace: 'pre-wrap',
                                wordWrap: 'break-word',
                            }}>{formatJSON(dados)}</pre>
                        ) : (
                            <MDTypography variant="body2">
                                {dados || "Sem informações"}
                            </MDTypography>
                        )}
                    </MDTypography>
                </MDBox>
            </Card>
        </Modal>
    );
}

// Typechecking props for the MDDatePicker
MDModal.propTypes = {
    show: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    header: PropTypes.string.isRequired,
    dados: PropTypes.string.isRequired,
};

export default MDModal;
